import { render, staticRenderFns } from "./EducationalScheduleTimeForm.vue?vue&type=template&id=1d610497&"
import script from "./EducationalScheduleTimeForm.vue?vue&type=script&lang=js&"
export * from "./EducationalScheduleTimeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports